import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PlacementList = lazy(() =>
  import("@scenes/Placements/PlacementList/PlacementList").then((module) => ({
    default: module.PlacementList,
  }))
);

export const placementsNRO: NavigationRoutingObject = {
  Component: PlacementList,
  componentFeatureFlippers: ["banners", "placements_nro_component"],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("placements-nro-heading", "Banner Placements"),
  pageNameForTracking: () => "Banner Placements",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("placements-nro-description", "Manage the placement of banner campaigns"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("banners") &&
      featureOn("placements_nro_component") &&
      (hasPermission("appGroup", { permission: "basicReadOnly" }) ||
        (featureOn("content_cards_permissions_placements") &&
          hasPermission("appGroup", { permission: "viewPlacements" })))
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
